import { DotLoader } from 'components/Atoms/Loaders'

export const SingleDataLoader = ({ config = { loaderSizeInRem: 0.6 }, loading, data }) =>
  loading ? <DotLoader sizeInRem={config.loaderSizeInRem} /> : data ?? null
